/* AVORA — Quick Add to Cart (card "+" button) */
function avoraCardShopPath(path) {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  return root.replace(/\/$/, '') + '/' + String(path || '').replace(/^\//, '');
}

function avoraCardStatus(btn, message) {
  var card = btn.closest('.avora-card');
  var status = card ? card.querySelector('[data-avora-card-status]') : null;
  if (status) status.textContent = message || '';
}

window.avoraCardQuickAdd = function(btn) {
  if (btn.disabled || btn.classList.contains('is-loading')) return;

  var variantId = btn.dataset.variantId;
  if (!variantId) return;
  var quantity = Math.max(1, parseInt(btn.dataset.quantity || '1', 10) || 1);

  btn.classList.add('is-loading');
  btn.disabled = true;
  avoraCardStatus(btn, 'Adding ' + (btn.dataset.productTitle || 'item') + window.AvoraI18n.text(' to cart.'));

  /* Fire the cart API call immediately */
  fetch(avoraCardShopPath('cart/add.js'), {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: quantity }] })
  })
  .then(function(res) {
    return res.json().catch(function() { return {}; }).then(function(data) {
      if (!res.ok) throw new Error(data.description || data.message || window.AvoraI18n.text('We could not add this item. Please try again.'));
      return data;
    });
  })
  .then(function(payload) {
    btn.classList.add('is-added');
    btn.classList.remove('is-loading');
    avoraCardStatus(btn, (btn.dataset.productTitle || 'Item') + window.AvoraI18n.text(' added to cart.'));
    document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { source: 'product-card', payload: payload } }));

    /* Trigger fly-to-cart animation if available */
    if (window.avoraFlyToCart) {
      var card = btn.closest('.avora-card');
      var imgEl = card ? card.querySelector('.avora-card__image') : null;
      window.avoraFlyToCart({
        imageEl: imgEl,
        imageSrc: btn.dataset.productImage || (imgEl ? imgEl.src : ''),
        title: btn.dataset.productTitle || '',
        price: btn.dataset.productPrice || '',
        sourceEl: btn
      });
    }

    /* Update cart count */
    if (typeof updateCartCount === 'function') {
      updateCartCount();
    } else {
      fetch(avoraCardShopPath('cart.js'), { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          document.querySelectorAll('.cart-count-badge, [data-cart-count], .cart-bubble__text-count').forEach(function(b) {
            b.textContent = cart.item_count;
          });
        });
    }

    /* Revert button after 1.5s */
    setTimeout(function() {
      btn.classList.remove('is-added');
      btn.disabled = false;
    }, 1500);
  })
  .catch(function(error) {
    btn.classList.remove('is-loading');
    btn.disabled = false;
    avoraCardStatus(btn, error && error.message ? error.message : window.AvoraI18n.text('We could not add this item. Please try again.'));
    /* Brief error shake */
    btn.style.animation = 'avora-shake 0.4s ease';
    setTimeout(function() { btn.style.animation = ''; }, 500);
  });
};
